<template>
  <v-container class="py-0">
    <Navbar
      :hasDrawer="true"
      :title="`Produtos (${produtos.length})`"
    >
      <template slot="actions">
        <v-btn :loading="loading" icon @click="getProdutosAPI">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon @click="searchBox = !searchBox">
          <v-icon>{{ iconSearch }}</v-icon>
        </v-btn>
      </template>
    </Navbar>
    <v-row v-if="searchBox">
      <v-col cols="12" class="pb-0">
        <SearchBox
          id="searchBox"
          @search="filters.search = $event"
        />
      </v-col>
    </v-row>
    <ListProdutos
      :filters="filters"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListProdutos from '@/components/produtos/ListProdutos';
import SearchBox from '@/components/shared/SearchBox';

export default {
  name: 'Produtos',
  data: () => ({
    searchBox: false,
    loading: false,
    filters: {
      order: 'descricao',
      search: '',
    },
  }),
  components: {
    ListProdutos,
    SearchBox
  },
  watch: {
    searchBox(value) {
      if (value) this.$nextTick(() => document.getElementById('searchBox').focus());
      else this.filters.search = '';
    }
  },
  computed: {
    ...mapGetters(['produtos']),
    iconSearch() {
      return this.searchBox ? 'mdi-close' : 'mdi-magnify';
    }
  },
  methods: {
    ...mapActions(['fetchProdutos', 'fetchProdutosAPI']),
    getProdutos() {
      this.loading = true;
      this.fetchProdutos()
        .then(() => this.loading = false);
    },
    getProdutosAPI() {
      this.loading = true;
      this.fetchProdutosAPI()
        .then(() => this.loading = false);
    }
  },
  created() {
    if (!this.produtos.length) this.getProdutos();
  }
}
</script>

<style>

</style>